import styled from 'styled-components';

export const ImgUploadContainer = styled.div`
  border-radius: ${({ theme }) => theme.shapes.borderRadius};
  .ant-upload-select-picture {
    width: 100% !important;
  }

  .image-upload-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    min-height: 65px;
    border: 1px dashed ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    padding: 8px !important;
    background: ${({ theme }) => theme.colors.background};
    cursor: pointer;

    .image-upload-icon {
      font-size: 2rem;
      margin: 16px;

      svg {
        color: ${({ theme }) => theme.colors.border};
      }
    }

    p {
      color: ${({ theme }) => theme.colors.text1};
      margin: 0 !important;
    }

    .image-upload-title {
      font-weight: bold;
      font-size: 0.9rem;
      color: ${({ theme }) => theme.colors.text};
    }

    .image-upload-subtitle {
      font-size: 0.8rem;
      max-width: 300px;
    }
  }
`;
